//Style
import '../scss/style.scss';
import 'slick-carousel/slick/slick.scss';
//import '@fancyapps/fancybox/src/css/core.css';
//import '@fancyapps/fancybox/src/css/thumbs.css';

//Javascript
import jQuery from "jquery";
export {default as $} from 'jquery';
import 'bootstrap';
import SmoothScroll from './smooth-scroll';
import { gsap } from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import slick from "slick-carousel/slick/slick";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
//import { VanillaTilt } from "./tilt";
window.jQuery = jQuery;
//require("@fancyapps/fancybox");
gsap.registerPlugin(ScrollTrigger,DrawSVGPlugin);
const ss=new SmoothScroll({el:document.querySelector("[data-scroll-container]"),smooth:window.activeSmooth,getDirection:!0});ss.on("scroll",ScrollTrigger.update),ScrollTrigger.scrollerProxy(document.querySelector("[data-scroll-container]"),{scrollTop(e){return arguments.length?ss.scrollTo(e,0,0):ss.scroll.instance.scroll.y},getBoundingClientRect:()=>({top:0,left:0,width:window.innerWidth,height:window.innerHeight}),pinType:document.querySelector("[data-scroll-container]").style.transform?"transform":"fixed"}),ScrollTrigger.addEventListener("refresh",()=>ss.update()),ScrollTrigger.refresh(),ss.on("scroll",e=>{e.scroll.y>300?document.querySelectorAll("header")[0].classList.add("sticky"):document.querySelectorAll("header")[0].classList.remove("sticky");e.scroll.y>100&&"down"==e.direction?document.querySelectorAll("header")[0].classList.add("hide"):document.querySelectorAll("header")[0].classList.remove("hide")});

window.addEventListener("load", () => {
    jQuery('body').addClass('loaded');
    /*
    if (window.matchMedia("(min-width: 992px)").matches) {
        VanillaTilt.init(document.querySelectorAll(".tilt-transition"));
    }*/
});

window.addEventListener("resize", () => {
    //location.reload();
});


//WINE CAROUSEL
let wineCarousel = jQuery('.wine-menu__carousel').slick({
    arrows: false,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 720,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});

gsap.set(".draw-me", { drawSVG: '0%'});
gsap.set(".draw-me-2", { drawSVG: '0%'});
gsap.set(".draw-me-3", { drawSVG: '0%'});
gsap.set(".draw-me-4", { drawSVG: '0%'});
gsap.set(".draw-me-5", { drawSVG: '0%'});
setTimeout(function () {

    var tl = gsap.timeline();

    tl.to(".draw-me", {duration:0.75, drawSVG: '100%'})
    .to(".draw-me-2", {duration:0.75, drawSVG: '100%'})
    .to(".draw-me-3", {duration:0.5, drawSVG: '100%'})
    .to(".draw-me-4", {duration:0.75, drawSVG: '100%'})
    .to(".draw-me-5", {duration:1.25, drawSVG: '100%'});
},1000);


jQuery(".wine-menu__carousel-prev").click(function(e){
    wineCarousel.slick('slickPrev');
});

jQuery(".wine-menu__carousel-next").click(function(e){
    wineCarousel.slick('slickNext');
});

//HOME CAROUSEL
let homeCarousel = jQuery('.home__carousel').slick({
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: true,
    infinite: true
});

jQuery(".home__carousel-next").click(function(e){
    homeCarousel.slick('slickPrev');
});

jQuery(".home__carousel-prev").click(function(e){
    homeCarousel.slick('slickNext');
});


jQuery('.wine-menu__close').click(function (e) {
    jQuery('.wine-menu').removeClass('open');
});

jQuery('.wine-menu__open').click(function (e) {
    jQuery('.wine-menu').addClass('open');
});

jQuery('.site__menuToggle').click(function (e) {

    e.preventDefault();



    if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active');
        var TLmenu = new gsap.timeline({
            onStart: () => {

            },
            onComplete: () => {
                jQuery('.site__menumobile').removeClass('show');
            }
        });

        TLmenu
            .to(".site__menumobile", {
                    duration: .5,
                    x : '100%',
                }
            );
    } else {
        jQuery(this).addClass('active');
        var TLmenu = new gsap.timeline({
            onStart: () => {
                jQuery('.site__menumobile').addClass('show');
            },
            onComplete: () => {

            }
        });

        TLmenu
            .to(".site__menumobile", {
                    duration: .5,
                    x : '0%',
                }
            );
    }




});
